package er.prateek.crossly.persistence

import er.prateek.crossly.share.IncomingChallenge
import er.prateek.crossly.share.IncomingChallengePrefs
import er.prateek.crossly.share.IncomingChallengeStatus

interface IncomingChallengeStore {
    fun load(): IncomingChallengePrefs
    fun save(prefs: IncomingChallengePrefs)
}

fun IncomingChallengeStore.upsertChallenge(challenge: IncomingChallenge) {
    save(load().copy(challenge = challenge))
}

fun IncomingChallengeStore.setStatus(status: IncomingChallengeStatus) {
    val current = load().challenge ?: return
    save(load().copy(challenge = current.copy(status = status)))
}

fun IncomingChallengeStore.markReferrerConsumed() {
    save(load().copy(referrerConsumed = true))
}
